import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@material-ui/core";

export const MissingRoute: React.FC = () => {
  return (
    <Dialog open maxWidth="md" fullWidth>
      <DialogTitle>Access a Shared Resource</DialogTitle>
      <DialogContent>
        <p>
          You are visiting an unknown shared resource, please double-check the
          link that you have received.
        </p>
      </DialogContent>
      <DialogActions></DialogActions>
    </Dialog>
  );
};
